<template>
    <div class="bg">
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-grupo-usuario') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="usuarioSelected.length === 0 && !isEdit"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="search-and-filter" v-if="!isEdit">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper" v-if="!isEdit">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="grupos"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="usuarioSelected"
                :custom-is-checked="(selecionados, linha) => selecionados.idusuario === linha.idusuario"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
    </div>
</template>

<script>
import AssUsuarioCentroCustoService from "@/services/vendas/financeiro/AssUsuarioCentroCustoService";
import Message from "@/models/Message";

export default {
    props: {
        idgrupoproduto: 0
    },
    data() {
        return {
            service: new AssUsuarioCentroCustoService(this.$http, this.$router),
            grupos: [],
            isLoading: false,
            isEmpty: false,
            isEdit: false,
            fields: [
                {key: 'nome', width: null, sortable: true, sortFn: null},
            ],
            usuarioSelected: [],
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;
            this.service
                .findUsuariosNaoAssociados(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.idgrupoproduto,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then(value => {
                    this.grupos = value;
                    this.isEmpty = this.grupos.length === 0;
                })
                .catch(e => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map(m => {
                return {
                    idusuario: m.idusuario,
                    nome: m.nome
                };
            });
        },
        mapOnSave(itens) {
            return itens.map(m => {
                return {
                    idfin_centro_custo: this.$route.params.id,
                    idusuario: m.idusuario,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.usuarioSelected.length > 0) {
                this.isLoading = true;

                this.service
                    .save(this.mapOnSave(this.usuarioSelected))
                    .then(value => {
                        if (value.content === null) {
                            this.msgs.push(new Message("error", `${value.message}`, true));
                        } else {
                            this.onFecharModal()
                            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message("alert", 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-usuario', true));
                this.isLoading = false;
            }
        },
        onFecharModal(){
            this.isEdit = false
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>